// Clerk-token → Authorization header. Returned as a stable callback so
// callers can await fresh headers on each request (the token rotates).

import React from "react";
import { useAuth } from "@clerk/clerk-react";

export type AuthHeaders = (fresh?: boolean) => Promise<HeadersInit>;

export function useAuthHeaders(): AuthHeaders {
  const { getToken } = useAuth();
  return React.useCallback(
    async (fresh = false): Promise<HeadersInit> => {
      const token = await getToken(fresh ? { skipCache: true } : undefined);
      if (fresh && !token)
        throw new Error(
          "Couldn't refresh your session. Try again in a moment.",
        );
      return token ? { Authorization: `Bearer ${token}` } : {};
    },
    [getToken],
  );
}
